import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface LoginRequestCreateDto {
  descopeSessionToken: string;
  descopeRefreshToken: string;
}

export interface LoginRequestResponse {
  id: string;
  message: string; // Ensure we capture the message from the creation response
  status?: string;
}

@Injectable({
  providedIn: 'root'
})
export class LoginRequestService {
  private http = inject(HttpClient);

  // Base URL for creation (keep as is based on your previous file)
  private readonly baseUrl = `${environment.coreApiBaseUrl}/login-requests`;

  /**
   * Creates a new login request.
   * POST /login-requests
   */
  createLoginRequest(payload: LoginRequestCreateDto): Observable<LoginRequestResponse> {
    return this.http.post<LoginRequestResponse>(this.baseUrl, payload);
  }

  /**
   * Polls the auth endpoint using the ID in the URL and message in the body.
   * POST /auth/login-by-approved-login-request/{id}
   * Body: { "message": "..." }
   */
  loginByApprovedLoginRequest(id: string, message: string): Observable<HttpResponse<any>> {
    // Construct the specific URL from your curl command
    const url = `${environment.coreApiBaseUrl}/auth/login-by-approved-login-request/${id}`;

    return this.http.post<any>(
      url,
      { message: message },
      { observe: 'response' } // We need the full response to read headers
    );
  }
}